import { HttpPollingRequestInit, HttpRequestInit } from './http-request/http-request';

/**
 * Utility class
 */
export class HttpUtilService {
  /**
   * Method to initialise headers for a http api call
   * @returns HttpRequestInit response
   * ```
   * @example
   * const initApi = this.initHeader()
   * ```
   */
  public initHeader(token?: string, contentType?: string): HttpRequestInit {
    const reqInit: HttpRequestInit = {
      headers: [],
    };
    if (reqInit.headers && token) {
      const tokenHeader = {
        name: 'Authorization',
        value: 'Bearer ' + token,
      };
      reqInit.headers.push(tokenHeader);
    }
    if (reqInit.headers && contentType) {
      const tokenHeader = {
        name: 'Content-Type',
        value: contentType,
      };
      reqInit.headers.push(tokenHeader);
    }

    return reqInit;
  }

  /**
   * Method to initialise headers for a http api call using fetch
   * @returns HttpPollingRequestInit response
   * ```
   * @example
   * const initApi = this.initPollingHeader()
   * ```
   */
  public initPollingHeader(
    token?: string,
    contentType?: string
  ): HttpPollingRequestInit {
    const reqInit: HttpPollingRequestInit = {
      headers: {
        'Content-Type': contentType,
        Authorization: 'Bearer ' + token,
      },
    };
    return reqInit;
  }
}
